import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/image/logo.png'


const _hoisted_1 = { style: {"display":"flex","flex-direction":"column","height":"100%"} }
const _hoisted_2 = {
  id: "header",
  style: {"display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"center","height":"50px","z-index":"1","box-shadow":"0px 0px 10px rgba(0, 0, 0, 0.2)"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"36px","width":"36px","border-radius":"20px"},
  src: _imports_0
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 退出 ")
const _hoisted_5 = { style: {"display":"flex","flex-direction":"row","flex":"auto"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "首页", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "用户", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "表情提取", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "B站", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "安全审核", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "表情举报", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "App日志", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "bot", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "设置", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_i_monitor = _resolveComponent("el-i-monitor")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_i_user = _resolveComponent("el-i-user")!
  const _component_el_i_warning = _resolveComponent("el-i-warning")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_i_picture = _resolveComponent("el-i-picture")!
  const _component_el_i_document = _resolveComponent("el-i-document")!
  const _component_el_i_chat_dot_round = _resolveComponent("el-i-chat-dot-round")!
  const _component_el_i_setting = _resolveComponent("el-i-setting")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_dropdown, {
        onCommand: _ctx.onCommand,
        trigger: "hover",
        style: {"margin-right":"30px"}
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, { index: "/" }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onCommand"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_menu, {
        router: "",
        "default-active": "/",
        class: "el-menu-vertical-demo",
        style: {"width":"300px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_menu_item, { index: "/" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_i_monitor)
                ]),
                _: 1
              }),
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/user/user-list" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_i_user)
                ]),
                _: 1
              }),
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_el_sub_menu, null, {
            title: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_i_warning)
                ]),
                _: 1
              }),
              _hoisted_8
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/cropper/bilibili-crop-request" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_i_user)
                    ]),
                    _: 1
                  }),
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_sub_menu, null, {
            title: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_i_warning)
                ]),
                _: 1
              }),
              _hoisted_10
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/censor/img-report-list" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_i_picture)
                    ]),
                    _: 1
                  }),
                  _hoisted_11
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/app-log" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_i_document)
                ]),
                _: 1
              }),
              _hoisted_12
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/bot" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_i_chat_dot_round)
                ]),
                _: 1
              }),
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/config" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_i_setting)
                ]),
                _: 1
              }),
              _hoisted_14
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_router_view, { style: {"flex":"auto"} })
    ])
  ]))
}